import { render, staticRenderFns } from "./TypeFilter.vue?vue&type=template&id=23f96011&scoped=true&"
import script from "./TypeFilter.vue?vue&type=script&lang=js&"
export * from "./TypeFilter.vue?vue&type=script&lang=js&"
import style0 from "./TypeFilter.vue?vue&type=style&index=0&id=23f96011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f96011",
  null
  
)

export default component.exports